import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { useSelectDevice } from '@shared/hooks/use-select-device'

import styles from './style.module.scss'

export const View = () => {
	return (
		<Section className={styles.wrapper}>
			<div className={styles.top}>
				<div>
					<h2 className={styles.title}>Мы руководствуемся простыми ценностями</h2>
					<h3 className={styles.subtitle}>Честность</h3>
					<p className={styles.text}>
						Работаем строго по&nbsp;договору, без скрытых условий, штрафов и&nbsp;сносок, написанных
						мелким шрифтом.
					</p>
				</div>
				<div>
					<div className={styles.imgWrapper}>
						<Image
							lazy
							name={useSelectDevice({
								mobile: 'dogovor-zaima-mob.png',
								tablet: 'dogovor-zaima-tablet.png',
								default: 'dogovor-zaima.png',
							})}
						/>
					</div>
				</div>
			</div>
			<div className={styles.bottom}>
				<div className={styles.bottomText}>
					<h3 className={styles.subtitle}>Доверие</h3>
					<p className={styles.text}>
						Мы&nbsp;всегда объясняем детали сделки, подробно отвечаем на&nbsp;вопросы и&nbsp;даём
						время на&nbsp;принятие решения. Если у&nbsp;клиента возникнут финансовые трудности,
						мы&nbsp;готовы пойти навстречу и&nbsp;найти выход.
					</p>
				</div>
				<Image
					lazy
					name={useSelectDevice({
						mobile: 'our-values-dialog-mob.png',
						tablet: 'our-values-dialog-mob.png',
						default: 'our-values-dialog.png',
					})}
					className={styles.dialogImg}
				/>
			</div>
		</Section>
	)
}
